// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AuthConfig } from "angular-oauth2-oidc";

export const environment = {
    //serviceBaseUrl: 'https://apigw.etfr.eurofins.com/myexportuat/',
    //serviceBaseUrl: 'https://trunk-dev-int-eol.digital-online.eurofins.local/myexportserver/',
    production: false,
    appName: 'My Export Eurofins',
    // appCode: 'APP0000041',
    name: 'My Export UAT',
    //name: 'My Export UAT (ES)',
    // launcherUrl: 'https://launchertest.env.eurofins.fr/',
};

export const authConfig: AuthConfig = {


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
